import { render, staticRenderFns } from "./questesType.vue?vue&type=template&id=5e1a7328&scoped=true"
import script from "./questesType.vue?vue&type=script&lang=js"
export * from "./questesType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1a7328",
  null
  
)

export default component.exports